var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video-player',{staticClass:"kf-video",attrs:{"options":{
    sources: [{ type: 'application/x-mpegurl', src: this.src }],
    autoplay: this.autoplay,
    poster: this.poster,
    muted: this.muted,
    controls: this.controls,
    preload: this.preload,
    fluid: this.fluid,
    loop: this.loop
  },"playsinline":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }